import React, { useState } from "react";

const MahilaMandiLeadHub = () => {
  const [leads, setLeads] = useState([
    {
      id: 1,
      title: "Batch of 500 Handmade Soaps",
      type: "Production Order",
      category: "Handmade Goods",
      location: "Nashik, Maharashtra",
      status: "New",
    },
    {
      id: 2,
      title: "1 Loom Rental for Weaving Enterprise",
      type: "Rental",
      category: "Equipment",
      location: "Indore, MP",
      status: "In Progress",
    },
    {
      id: 3,
      title: "Export Inquiry for Embroidered Textiles",
      type: "Export Lead",
      category: "Export-Import",
      location: "Dubai, UAE",
      status: "New",
    },
    {
      id: 4,
      title: "Training Service for Pickle Making",
      type: "Service Request",
      category: "Skill Training",
      location: "Karnal, Haryana",
      status: "Closed",
    },
    {
      id: 5,
      title: "Bulk Order for Herbal Tea Blends",
      type: "Purchase",
      category: "Handmade Goods",
      location: "Jaipur, Rajasthan",
      status: "New",
    },
    {
      id: 6,
      title: "Jewelry Workshop Space Rental",
      type: "Rental",
      category: "Equipment",
      location: "Kolkata, West Bengal",
      status: "In Progress",
    },
    {
      id: 7,
      title: "Import Lead for Natural Dyes",
      type: "Import Lead",
      category: "Export-Import",
      location: "Bangkok, Thailand",
      status: "New",
    },
    {
      id: 8,
      title: "Packaging Design Service Needed",
      type: "Service Request",
      category: "Design Service",
      location: "Chennai, Tamil Nadu",
      status: "Closed",
    },
    {
      id: 9,
      title: "Wholesale Pottery Clay Supply",
      type: "Supply Request",
      category: "Raw Materials",
      location: "Morbi, Gujarat",
      status: "In Progress",
    },
    {
      id: 10,
      title: "Batch of Woven Baskets for Sale",
      type: "Sale",
      category: "Handmade Goods",
      location: "Assam",
      status: "New",
    },
  ]);

  const [newLead, setNewLead] = useState({
    title: "",
    type: "",
    category: "",
    location: "",
    status: "New",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewLead({ ...newLead, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newLead.title || !newLead.type || !newLead.category || !newLead.location) {
      alert("Please fill in all fields before submitting.");
      return;
    }
    setLeads([...leads, { id: leads.length + 1, ...newLead }]);
    setNewLead({ title: "", type: "", category: "", location: "", status: "New" });
  };

  return (
    <div>
      <section className="py-2 px-4 md:px-8 bg-black text-white min-h-screen">
        {/* Hero Section */}
        <div className="text-center mb-4 py-4 px-4 border border-green-500">
          <h1 className="text-xl md:text-2xl font-bold text-yellow-200 mb-4">
            👩‍🔧 MahilaMandi Lead Hub
          </h1>
          <p className="text-white mx-auto">
            Manage all your women-led enterprise opportunities — production orders, supplies, rentals, and global trade leads — in one place.
          </p>
        </div>

        {/* Form to Create New Lead */}
        <div className="max-w-3xl mx-auto bg-black border text-white border-green-500 shadow-lg rounded-2xl p-6 mb-12">
          <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mb-4">Create New Lead</h2>
          <form onSubmit={handleSubmit} className="grid gap-4">
            <input
              type="text"
              name="title"
              value={newLead.title}
              onChange={handleChange}
              placeholder="Lead Title (e.g., Batch of 200 Handmade Soaps)"
              className="border rounded-lg px-3 py-2 w-full text-black"
            />

            <select
              name="type"
              value={newLead.type}
              onChange={handleChange}
              className="border rounded-lg px-3 py-2 w-full h-10 text-black"
            >
              <option value="">Select Lead Type</option>
              <option>Production Order</option>
              <option>Purchase</option>
              <option>Sale</option>
              <option>Rental</option>
              <option>Service Request</option>
              <option>Export Lead</option>
              <option>Import Lead</option>
              <option>Supply Request</option>
            </select>

            <select
              name="category"
              value={newLead.category}
              onChange={handleChange}
              className="border rounded-lg px-3 py-2 w-full h-10 text-black"
            >
              <option value="">Select Category</option>
              <option>Handmade Goods</option>
              <option>Raw Materials</option>
              <option>Equipment</option>
              <option>Skill Training</option>
              <option>Design Service</option>
              <option>Export-Import</option>
            </select>

            <input
              type="text"
              name="location"
              value={newLead.location}
              onChange={handleChange}
              placeholder="Location (e.g., Pune, Maharashtra)"
              className="border rounded-lg px-3 py-2 w-full text-black"
            />

            <button
              type="submit"
              className="bg-green-700 text-white py-2 w-40 rounded-lg hover:bg-green-800 transition"
            >
              + Add Lead
            </button>
          </form>
        </div>

        {/* Leads Table */}
        <div className="max-w-5xl mx-auto overflow-x-auto">
          <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mb-6">All Leads</h2>
          <table className="w-full border-collapse bg-gray-700 shadow-lg rounded-xl overflow-hidden">
            <thead className="bg-green-700 text-white">
              <tr>
                <th className="p-3 text-left">Title</th>
                <th className="p-3 text-left">Type</th>
                <th className="p-3 text-left">Category</th>
                <th className="p-3 text-left">Location</th>
                <th className="p-3 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((lead) => (
                <tr key={lead.id} className="border-b hover:bg-gray-600">
                  <td className="p-3">{lead.title}</td>
                  <td className="p-3">{lead.type}</td>
                  <td className="p-3">{lead.category}</td>
                  <td className="p-3">{lead.location}</td>
                  <td className="p-3">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        lead.status === "New"
                          ? "bg-green-100 text-green-700"
                          : lead.status === "In Progress"
                          ? "bg-yellow-100 text-yellow-700"
                          : "bg-gray-200 text-gray-700"
                      }`}
                    >
                      {lead.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      {/* Footer */}
      <footer className="mt-16 bg-green-700 text-white py-8 px-4 sm:px-6 md:px-20 rounded-2xl">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">
            &copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <a
              href="#about"
              className="text-white hover:text-green-300 transition"
            >
              About
            </a>
            <a
              href="#privacy"
              className="text-white hover:text-green-300 transition"
            >
              Privacy Policy
            </a>
            <a
              href="#terms"
              className="text-white hover:text-yellow-300 transition"
            >
              Terms of Use
            </a>
            <a
              href="#contact"
              className="text-white hover:text-green-300 transition"
            >
              Contact
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MahilaMandiLeadHub;